module.exports = __webpack_public_path__ + "static/img/consult4-2.bc24deec.png";